import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { liveStats } from '@/mocks/evidence';

export default function LiveBoard() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="实时数据看板"
            title="核心运营指标"
            subtitle="以下数据来自九畴云市首发项目清单，属于项目规划与首发目标，实际以项目运营数据为准。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 rounded-lg bg-foreground-950 border border-foreground-800 p-6 md:p-8">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
                <span className="text-sm text-background-200">数据看板 · 0# 帝星场景</span>
              </div>
              <span className="text-xs text-foreground-500">更新于项目首发清单</span>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {liveStats.map((s) => (
                <div key={s.label} className="p-5 rounded-lg bg-foreground-900/60 border border-foreground-800">
                  <div className="font-heading font-bold text-3xl md:text-4xl text-accent-400">
                    {s.value}
                  </div>
                  <div className="mt-2 text-sm text-foreground-300 leading-snug">{s.label}</div>
                  <div className="mt-1 text-xs text-foreground-500">{s.trend}</div>
                </div>
              ))}
            </div>

            <p className="mt-6 text-xs text-foreground-500 leading-relaxed">
              注：以上数据来自九畴云市首发项目清单，属于项目规划与首发目标，实际以项目运营数据为准。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}